import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['menu', 'offcanvas', 'panel', 'toggleButton'];

	connect() {
		this.desktop = window.matchMedia('(min-width: 1088px)');
		this.onBreakpointChange = this.close.bind(this);
		this.desktop.addEventListener('change', this.onBreakpointChange);
	}

	disconnect() {
		this.desktop.removeEventListener('change', this.onBreakpointChange);
		this.close();
	}

	toggle(event) {
		if (this.menuTarget.hasAttribute('data-group-toggle')) {
			this.close(event);
			return;
		}

		this.menuTarget.setAttribute('data-group-toggle', 'true');
		this.offcanvasTarget.inert = false;
		this.offcanvasTarget.removeAttribute('aria-hidden');
		this.toggleButtonTarget.setAttribute('aria-expanded', 'true');
		document.documentElement.classList.add('overflow-hidden');
		this.panelTargets[0].querySelector('button, a, input, select').focus({ preventScroll: true });
	}

	showPanel(event) {
		for (const panel of this.panelTargets) {
			panel.hidden = panel.id !== event.currentTarget.getAttribute('aria-controls');
			if (!panel.hidden) {
				panel.querySelector('button, a, input, select').focus({ preventScroll: true });
			}
		}
		this.offcanvasTarget.scrollTop = 0;
	}

	close(event) {
		const wasOpen = this.menuTarget.hasAttribute('data-group-toggle');
		this.menuTarget.removeAttribute('data-group-toggle');
		this.toggleButtonTarget.setAttribute('aria-expanded', 'false');
		if (wasOpen && (event?.type === 'click' || event?.type === 'keydown')) {
			this.toggleButtonTarget.focus({ preventScroll: true });
		}
		this.offcanvasTarget.inert = true;
		this.offcanvasTarget.setAttribute('aria-hidden', 'true');
		for (const panel of this.panelTargets) {
			panel.hidden = panel.id !== 'mobile-menu-main';
		}
		this.offcanvasTarget.scrollTop = 0;
		document.documentElement.classList.remove('overflow-hidden');
	}
}
